export const TEST_ID = 'labeledToggle';

export const TOGGLE_TEST_ID = 'labeledToggleToggle';

export const VARIANT_SEGMENTED = 'segmented' as const;

export const VARIANT_SWITCH = 'switch' as const;
